import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Navigate, useParams } from 'react-router-dom';
import AddKeywordsDrawerContent from '../../KeywordTracker/components/keywords/drawers/AddKeywordsDrawerContent';
import { useMembershipWizard } from '../context/MembershipWizardContext';

const AddKeywords = () => {
  const { domain_slug } = useParams<{ domain_slug?: string }>();
  const [limitKeywords, setLimitKeywords] = useState(0);
  const membershipWizard = useMembershipWizard();
  const skipKeywordsStep = membershipWizard?.skipKeywordsStep ?? false;

  if (skipKeywordsStep) {
    return <Navigate to="/" replace />;
  }

  return (
    <Row className="justify-content-center mb-6 px-3">
      <Col xs={12} md={8}>
        <AddKeywordsDrawerContent
          domain_slug={domain_slug}
          isMemberStep
          limitKeywords={limitKeywords}
          setLimitKeywords={setLimitKeywords}
        />
      </Col>
    </Row>
  );
};

export default AddKeywords;
